import GlobalNavigationShell from "components/v2/global-navigation-shell/GlobalNavigationShell";
import LoanCentricSidebarNav from "components/v2/loan-centric-sidebar-nav/LoanCentricSidebarNav";
import ShellProfileOverlay from "components/v2/shell-profile-overlay/ShellProfileOverlay";
import useDesktopChecker from "hooks/useDesktopChecker";
import useTabletChecker from "hooks/useTabletChecker";
import HomeStub from "pages/home/HomeStub";

const HomeShellLayout = () => {
  const isDesktop = useDesktopChecker();
  const isTablet = useTabletChecker();
  const isMobilePhone = !isDesktop && !isTablet;

  return (
    <div className="dashboard-shell">
      <GlobalNavigationShell
        notificationsEnabled={false}
        shellContext="home"
        hideFooter
        navSlot={!isMobilePhone ? <LoanCentricSidebarNav /> : undefined}
        navSlotPlacement="sidebar"
      >
        <ShellProfileOverlay>
          <HomeStub />
        </ShellProfileOverlay>
      </GlobalNavigationShell>
    </div>
  );
};

export default HomeShellLayout;
